export function concat(a, b) {
    const c = new Uint8Array(a.length + b.length);
    c.set(a);
    c.set(b, a.length);
    return c;
}
const byteToHex = Array.from({ length: 256 }, (_, byte) => byte.toString(16).padStart(2, "0"));
export function toHex(bytes) {
    let encoded = "";
    for (const byte of bytes) {
        encoded += byteToHex[byte]; // eslint-disable-line @typescript-eslint/no-non-null-assertion -- Uint8Array values are guaranteed to be between 0 and 255
    }
    return encoded;
}
const utf8Encoder = new TextEncoder();
export function fromUtf8(input) {
    return utf8Encoder.encode(input);
}
const utf8Decoder = new TextDecoder("utf8", { fatal: true });
export function toUtf8(input) {
    return utf8Decoder.decode(input);
}
//# sourceMappingURL=bytes.js.map